import { render, staticRenderFns } from "./NextSection.vue?vue&type=template&id=4968259f&scoped=true&"
import script from "./NextSection.vue?vue&type=script&lang=js&"
export * from "./NextSection.vue?vue&type=script&lang=js&"
import style0 from "./NextSection.vue?vue&type=style&index=0&id=4968259f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4968259f",
  null
  
)

component.options.__file = "NextSection.vue"
export default component.exports